import { RedoOutlined } from '@ant-design/icons';
import React, { Component, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/common/Button';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-black">
          <div className="text-[28px] mb-4 text-color-text-1">
            <FormattedMessage id="Product-error" />
          </div>
          {this.state.error?.name === 'NotFoundError' ? (
            <div className="mb-8 text-color-text-2">
              <FormattedMessage id="The-translation-plugin-is-causing-product-error" />
            </div>
          ) : null}
          <Button type="primary" onClick={() => window.location.reload()}>
            <div>
              <RedoOutlined className="mr-1" />
              <FormattedMessage id="bc.refresh" />
            </div>
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
